import { createContext, useContext, useState, useCallback } from 'react';
import en from '../i18n/en.json';
import de from '../i18n/de.json';
import ua from '../i18n/ua.json';

const translations = { en, de, ua };
const STORAGE_KEY = 'creo_lang';
const LANGUAGES = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'de', label: 'DE', flag: '🇩🇪' },
  { code: 'ua', label: 'UA', flag: '🇺🇦' },
];

function getInitialLang() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && translations[stored]) return stored;
  } catch {}
  return 'en';
}

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((code) => {
    if (translations[code]) {
      setLangState(code);
      try { localStorage.setItem(STORAGE_KEY, code); } catch {}
    }
  }, []);

  const t = useCallback((path, params) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const key of keys) {
      val = val?.[key];
      if (val === undefined) {
        // Fallback to English
        let fallback = translations.en;
        for (const k of keys) { fallback = fallback?.[k]; }
        val = fallback;
        break;
      }
    }
    if (typeof val !== 'string') return path;
    if (params) {
      return Object.entries(params).reduce(
        (str, [k, v]) => str.replace(`{${k}}`, v),
        val
      );
    }
    return val;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, LANGUAGES }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used within LangProvider');
  return ctx;
}
